// extracted by mini-css-extract-plugin
export var deliveryRow = "_s0-a";
export var fixedHeight = "_s0-4";
export var freightLogo = "_s0-9";
export var fullWidth = "_s0-3";
export var priceColumn = "_s0-5";
export var radioSelected = "_s0-7";
export var radioUnselected = "_s0-6";
export var selectedOption = "_s0-2";
export var selectedOptionContainer = "_s0-1";
export var selection = "_s0-0";
export var tallSkeletonText = "_s0-8";